import { render, staticRenderFns } from "./weus.vue?vue&type=template&id=37ed362a&scoped=true"
import script from "./weus.vue?vue&type=script&lang=js"
export * from "./weus.vue?vue&type=script&lang=js"
import style0 from "./weus.vue?vue&type=style&index=0&id=37ed362a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ed362a",
  null
  
)

export default component.exports